import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { TESS_API_URL } from '@core/http/api.config';
import { SKIP_AUTH } from '@core/interceptors/skip-auth.context-token';
import { AuthService } from '@core/services/auth.service';
import { Observable } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  readonly #authService = inject(AuthService);
  readonly #tessApiUrl = inject(TESS_API_URL);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const accessToken = this.#authService.getAccessToken();

    if (req.context.get(SKIP_AUTH) || !accessToken || req.headers.has('Authorization') || !this.#isTessApiRequest(req.url)) {
      return next.handle(req);
    }

    return next.handle(
      req.clone({
        setHeaders: {
          Authorization: `Bearer ${accessToken}`,
        },
      }),
    );
  }

  #isTessApiRequest(requestUrl: string): boolean {
    const normalizedTessApiUrl = this.#tessApiUrl.replace(/\/$/, '');

    return requestUrl === normalizedTessApiUrl || requestUrl.startsWith(`${normalizedTessApiUrl}/`);
  }
}
